var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row bg-grey pt-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h3", { staticClass: "title-h3 border-bottom pb-3" }, [
          _c("button", {
            staticClass: "btn btn-back",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                _vm.$router.push("/users")
              }
            }
          }),
          _vm._v("\n        Back\n      ")
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        attrs: { autocomplete: "no" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            _vm.edit(_vm.user.id)
          },
          keydown: function($event) {
            _vm.clearError($event)
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "l-bg-white" },
          [
            _c("div", { staticClass: "row my-3" }, [
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c("div", { staticClass: "select-wrap" }, [
                    _c("label", [_vm._v("First name")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user.first_name,
                          expression: "user.first_name"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.user.first_name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.user, "first_name", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "first_name" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c("div", { staticClass: "select-wrap" }, [
                    _c("label", [_vm._v("Last name")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user.last_name,
                          expression: "user.last_name"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.user.last_name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.user, "last_name", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "last_name" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c("div", { staticClass: "select-wrap" }, [
                    _c("label", [_vm._v("Username")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user.username,
                          expression: "user.username"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.user.username },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.user, "username", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "username" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-3" }, [
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c("div", { staticClass: "select-wrap" }, [
                    _c("label", [_vm._v("Email")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user.email,
                          expression: "user.email"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "email" },
                      domProps: { value: _vm.user.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.user, "email", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "email" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c("div", { staticClass: "select-wrap" }, [
                    _c("label", [_vm._v("Phone")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user.phone,
                          expression: "user.phone"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        placeholder: "Enter Phone",
                        maxlength: "14"
                      },
                      domProps: { value: _vm.user.phone },
                      on: {
                        keydown: function($event) {
                          _vm.maskPhone($event)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.user, "phone", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "phone" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c(
                    "div",
                    { staticClass: "select-wrap" },
                    [
                      _c("label", [_vm._v("Status")]),
                      _vm._v(" "),
                      _c("simple-select", {
                        attrs: {
                          options: _vm.userStatuses,
                          placeholder: "Select Status"
                        },
                        model: {
                          value: _vm.user.user_status_id,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "user_status_id", $$v)
                          },
                          expression: "user.user_status_id"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "user_status_id" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-3" }, [
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c(
                    "div",
                    { staticClass: "select-wrap h-auto" },
                    [
                      _c("label", [_vm._v("Carriers")]),
                      _vm._v(" "),
                      _vm.userLoaded && _vm.carriers
                        ? _c("key-multiselect", {
                            attrs: {
                              "clear-on-select": false,
                              "hide-selected": true,
                              multiple: true,
                              options: _vm.listCarriers,
                              "preserve-search": false,
                              label: "name",
                              "track-by": "id"
                            },
                            on: { input: _vm.handleSelectAllCarriers },
                            scopedSlots: _vm._u([
                              {
                                key: "tag",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "multiselect__tag" },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(props.option.name))
                                        ]),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "multiselect__tag-icon",
                                          on: {
                                            click: function($event) {
                                              props.remove(props.option)
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.user.carriers,
                              callback: function($$v) {
                                _vm.$set(_vm.user, "carriers", $$v)
                              },
                              expression: "user.carriers"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "carriers" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c(
                    "div",
                    { staticClass: "select-wrap h-auto" },
                    [
                      _c("label", [_vm._v("Role")]),
                      _vm._v(" "),
                      _vm.userLoaded && _vm.roles
                        ? _c("key-multiselect", {
                            attrs: {
                              options: _vm.rolesFromCarrier,
                              multiple: true,
                              "clear-on-select": false,
                              "hide-selected": true,
                              "preserve-search": false,
                              label: "name",
                              "track-by": "id"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "tag",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "multiselect__tag" },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(props.option.name))
                                        ]),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "multiselect__tag-icon",
                                          on: {
                                            click: function($event) {
                                              props.remove(props.option)
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.user.roles,
                              callback: function($$v) {
                                _vm.$set(_vm.user, "roles", $$v)
                              },
                              expression: "user.roles"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "roles" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-4" }, [
                _c(
                  "div",
                  { staticClass: "select-wrap" },
                  [
                    _c("label", [_vm._v("Timezone")]),
                    _vm._v(" "),
                    _c("simple-select", {
                      attrs: {
                        options: _vm.timezones,
                        placeholder: "Select time zone"
                      },
                      model: {
                        value: _vm.user.timezone,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "timezone", $$v)
                        },
                        expression: "user.timezone"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-3" }, [
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c(
                    "div",
                    { staticClass: "select-wrap" },
                    [
                      _c("label", [_vm._v("Company")]),
                      _vm._v(" "),
                      _c("list-multiselect", {
                        attrs: {
                          options: _vm.companies,
                          "track-by": "id",
                          label: "name"
                        },
                        on: {
                          change: function(options) {
                            return (_vm.user.companies = options)
                          }
                        },
                        model: {
                          value: _vm.user.companies,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "companies", $$v)
                          },
                          expression: "user.companies"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "companies" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-4" }, [
                _c("div", { staticClass: "d-flex align-items-center pl-2" }, [
                  _c("span", { staticClass: "pr-2" }, [
                    _vm._v(
                      "\n              Receive automated update emails\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "switch mr-2" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user.receive_notifications,
                          expression: "user.receive_notifications"
                        }
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.user.receive_notifications)
                          ? _vm._i(_vm.user.receive_notifications, null) > -1
                          : _vm.user.receive_notifications
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.user.receive_notifications,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.user,
                                  "receive_notifications",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.user,
                                  "receive_notifications",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.user, "receive_notifications", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "slider round" })
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.notificationTypes && _vm.notificationTypes.length
              ? [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("section", [
                    _c(
                      "div",
                      { staticClass: "row mb-2 user-role" },
                      _vm._l(_vm.notificationTypes, function(type, index) {
                        return _c(
                          "div",
                          {
                            key: type.id,
                            staticClass:
                              "col-5 d-flex justify-content-between align-items-center"
                          },
                          [
                            _c("div", { staticClass: "d-flex flex-column" }, [
                              _vm.notification_type_ids.find(function(el) {
                                return el.via_role === true
                              })
                                ? _c("span", [
                                    _vm._v(
                                      "\n                  This notification is assigned via role.\n                "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "check-field" }, [
                                _c(
                                  "label",
                                  {
                                    class: [
                                      {
                                        "check-open": _vm.notification_type_ids.find(
                                          function(el) {
                                            return el.id === type.id
                                          }
                                        )
                                      },
                                      {
                                        disabled: _vm.notification_type_ids.find(
                                          function(el) {
                                            return el.via_role === true
                                          }
                                        )
                                      }
                                    ],
                                    attrs: {
                                      for: "notification_types_id-" + type.id
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "checkmark" }),
                                    _vm._v(_vm._s(type.description)),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.notification_type_ids,
                                          expression: "notification_type_ids"
                                        }
                                      ],
                                      key: index,
                                      staticClass: "btn-check",
                                      attrs: {
                                        type: "checkbox",
                                        id: "notification_types_id-" + type.id,
                                        disabled: _vm.notification_type_ids.find(
                                          function(el) {
                                            return el.via_role === true
                                          }
                                        )
                                      },
                                      domProps: {
                                        value: _vm.notification_type_ids.find(
                                          function(el) {
                                            return el.id === type.id
                                          }
                                        )
                                          ? _vm.notification_type_ids.find(
                                              function(el) {
                                                return el.id === type.id
                                              }
                                            )
                                          : type,
                                        checked: Array.isArray(
                                          _vm.notification_type_ids
                                        )
                                          ? _vm._i(
                                              _vm.notification_type_ids,
                                              _vm.notification_type_ids.find(
                                                function(el) {
                                                  return el.id === type.id
                                                }
                                              )
                                                ? _vm.notification_type_ids.find(
                                                    function(el) {
                                                      return el.id === type.id
                                                    }
                                                  )
                                                : type
                                            ) > -1
                                          : _vm.notification_type_ids
                                      },
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$a = _vm.notification_type_ids,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = _vm.notification_type_ids.find(
                                                  function(el) {
                                                    return el.id === type.id
                                                  }
                                                )
                                                  ? _vm.notification_type_ids.find(
                                                      function(el) {
                                                        return el.id === type.id
                                                      }
                                                    )
                                                  : type,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.notification_type_ids = $$a.concat(
                                                    [$$v]
                                                  ))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.notification_type_ids = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.notification_type_ids = $$c
                                            }
                                          },
                                          function($event) {
                                            _vm.change(type)
                                          }
                                        ]
                                      }
                                    })
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            !type.disabled_only_own
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center pl-2"
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "pr-2",
                                        class: {
                                          disabled: _vm.disabledAllLeads
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  All leads\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      { staticClass: "switch mr-2" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.onlyOwn,
                                              expression: "onlyOwn"
                                            }
                                          ],
                                          class: {
                                            disabled: _vm.disabledSwitch
                                          },
                                          attrs: {
                                            type: "checkbox",
                                            disabled: _vm.disabledSwitch
                                          },
                                          domProps: {
                                            value: _vm.notification_type_ids.find(
                                              function(el) {
                                                return el.id === type.id
                                              }
                                            ),
                                            checked: Array.isArray(_vm.onlyOwn)
                                              ? _vm._i(
                                                  _vm.onlyOwn,
                                                  _vm.notification_type_ids.find(
                                                    function(el) {
                                                      return el.id === type.id
                                                    }
                                                  )
                                                ) > -1
                                              : _vm.onlyOwn
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.toggleSwitch(
                                                _vm.notification_type_ids.find(
                                                  function(el) {
                                                    return el.id === type.id
                                                  }
                                                )
                                              )
                                            },
                                            change: function($event) {
                                              var $$a = _vm.onlyOwn,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = _vm.notification_type_ids.find(
                                                    function(el) {
                                                      return el.id === type.id
                                                    }
                                                  ),
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.onlyOwn = $$a.concat([
                                                      $$v
                                                    ]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.onlyOwn = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.onlyOwn = $$c
                                              }
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "slider round"
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        class: { disabled: _vm.disabledOnlyOwn }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Only own\n                "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      })
                    )
                  ])
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-5" }, [
              _c("div", { staticClass: "col pb-2 pt-2 text-right" }, [
                _vm.$_can("clusters.users.update")
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-primary ld-ext-right",
                        class: _vm.loadingButton ? "running" : "",
                        attrs: { disabled: _vm.buttonDisabled }
                      },
                      [
                        _vm._v("\n            Save\n            "),
                        _c("div", { staticClass: "ld ld-ball ld-flip" })
                      ]
                    )
                  : _vm._e()
              ])
            ])
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-4" }, [
      _c("div", { staticClass: "col" }, [
        _c("h2", { staticClass: "l-header-2" }, [_vm._v("Notification types")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f03d96b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f03d96b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/UsersEdit.vue
// module id = null
// module chunks = 